<template>
  <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
    <div class="flex flex-col">
      <div class="page-content">
        <h2>Visual Acuity Data for Imaging Study</h2>
        <form class="va-form">
          <div class="chart-options">
            <div>
              <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-2 uppercase text-xs">
                  <p>
                    <label for="name" class="text-gray-800 px-1">Chart Type</label>
                  </p>
                </div>
                <dropdown v-model="chart" :options="chartTypes"></dropdown>
              </div>
              <!-- <label>Chart Type</label>
              <select v-model="chart">
                <option v-for="chartType of chartTypes" :value="chartType" :key="chartType">{{ chartType }}</option>
              </select><br /> -->
            </div>
            <div>
              <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
                  <p>
                    <label for="name" class="text-gray-800 px-2">Chart Metric</label>
                  </p>
                </div>
                <dropdown v-if="chart == 'LogMAR'" v-model="metric" :options="['LogMAR']"></dropdown>
                <dropdown v-else v-model="metric" :options="['feet', 'metres']"></dropdown>
                <!-- <select v-if="chart == 'LogMAR'" v-model="metric">
                    <option>LogMAR</option>
                </select>
                <select v-else v-model="metric">
                    <option>feet</option>
                    <option>metres</option>
                </select>-->
              </div>
                <!-- <label>Metric</label>
                <select v-if="chart == 'LogMAR'" v-model="metric">
                    <option>LogMAR</option>
                </select>
                <select v-else v-model="metric">
                    <option>feet</option>
                    <option>metres</option>
                </select> -->
            </div>
            <label><input type="checkbox" v-model="correction">Wearing contacts or glasses?</label>
            <label><input type="checkbox" v-model="pinHole">Pin-hole?</label>
            <input type="submit">
          </div>
            <div class="laterality">
              <label>LEFT EYE</label>
              <input type="range" min="0" max="15" step="1" v-model="leftEyeScoreIndex">
              <label class="score">{{chartValues[metric][15-leftEyeScoreIndex]}}</label>
              <!--<label class="score" v-if="metric">{{chartValue[15-leftEyeScoreIndex]}}</label>-->
              <!-- <label if.bind="metric=='Feet'" class="score">${feetScores[15-leftEyeScoreIndex]}</label>
              <label if.bind="metric=='LogMAR'" class="score">${metreScores[15-leftEyeScoreIndex]}</label> -->
              <label class="logMAR">{{chartValues.logMar[15-leftEyeScoreIndex]}}</label>
            </div>
            <div class="va-scores">
              <ul>
                <li v-for="score of chartValues[metric]" :key="score"> {{score}} </li>
              </ul>
              <label class="score">Snellen</label>
              <label class="logmar">LogMAR</label>
            </div>
            <div class="laterality">
                <label>RIGHT EYE</label>
                <input type="range" min="0" max="15" step="1" v-model="rightEyeScoreIndex">
                <label class="score">{{chartValues.metres[15-rightEyeScoreIndex]}}</label>
                <!-- <label if.bind="metric=='Feet'" class="score">${feetScores[15-rightEyeScoreIndex]}</label>
                <label if.bind="metric=='LogMAR'" class="score">${metreScores[15-rightEyeScoreIndex]}</label> -->
                <label class="logMAR">{{chartValues.metres[15-rightEyeScoreIndex]}}</label>
            </div>
        </form>
      </div>
      <div class="w-full">
        <button @click="recordResult">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue'

export default {
  data () {
    return {
      chart: 'Snellen - E',
      chartTypes: ['Snellen - E', 'Snellen - Letter', 'LogMAR'],
      chartValues: {
        feet: ['No light perception', '<20/200', '20/200', '20/160', '20/125', '20/100', '20/80', '20/63', '20/50', '20/40', '20/32', '20/25', '20/20', '20/16', '20/12.5', '20/10'],
        logMar: ['No light perception', '<1.00', '1.00', '0.90', '0.80', '0.70', '0.60', '0.50', '0.40', '0.30', '0.20', '0.10', '0.00', '-0.10', '-0.20', '-0.30'],
        metres: ['No light perception', '<6/60', '6/60', '6/48', '6/38', '6/30', '6/24', '6/19', '6/15', '6/12', '6/9.5', '6/7.5', '6/6', '6/4.8', '6.3.8', '6/3']
      },
      correction: false,
      leftEyeScoreIndex: '7',
      observations: [
        {
          bodySite: {},
          code: 'visual_acuity_od',
          coding: [
            { code: 'locsiii_od' },
            { display: 'LOCSIII (OD)' },
            { system: 'clinres' }
          ],
          laterality: 'right',
          value: ''
        },
        {
          bodySite: {},
          code: 'visual_acuity_os',
          coding: [
            { code: 'locsiii_os' },
            { display: 'LOCSIII (OS)' },
            { system: 'clinres' }
          ],
          laterality: 'left',
          value: ''
        }
      ],
      pinHole: false,
      metric: 'metres',
      rightEyeScoreIndex: '7'
    }
  },
  computed: {
    // chartValue () {
    //   return this.chartValues[this.metric]
    // }
  },
  components: {
    Dropdown
  },
  methods: {
    recordResult () {
      this.$emit('recordResult', { OD: this.chartValues.logMar[15 - this.rightEyeScoreIndex], OS: this.chartValues.logMar[15 - this.leftEyeScoreIndex] })
    }
  }
}
</script>

<style scoped>
.va-form {
  display: flex;
  justify-content: space-around;
  width: 700px;
  margin: 0 auto;
  padding: 10px;
  background: #F5F5F5;
  border: 1px solid white;
  color: #212121;
}

.chart-options {
  flex-grow: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.laterality {
  display: flex;
  flex-direction: column;
}

.laterality label {
  margin: 0 auto;
  padding-bottom: 5px;
  font-size: 16px;
}

.laterality .score {
  font-size: 24px;
  padding: 15px 0 15px 0;
}

.laterality .logMAR {
  font-size: 12px;
}

.laterality input[type=range] {
  -webkit-appearance: slider-vertical;
  margin: 0 auto;
  height: 425px;
}

.va-scores ul {
  padding-top: 22px;
}

.va-scores li {
  font-size: 14px;
  padding-bottom: 6px;
  text-align: center;
}

.va-scores label {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.va-scores .score {
  font-size: 22px;
  margin: 0 auto;
  padding: 0px 0 0px 0;
}

.va-scores .logmar {
  font-size: 12px;
  padding-top: 10px;
}
</style>
